// Icon — React-Bruecke auf das bestehende Lorath-SVG-Sprite.
// Quelle: src/assets/icons-sprite.svg (KOPIE von public/img/icons/sprite.svg —
// bei Icon-Aenderungen beide pflegen bzw. `node scripts/build-icon-sprite-js.js`
// laufen lassen und neu kopieren; wird beim Cutover zur Single Source).
//
// Mechanik wie Legacy lorath-icons.js: Das Sprite wird EINMAL versteckt in den
// DOM injiziert (inline, kein Fetch — funktioniert offline + in WKWebView, wo
// externe <use>-Referenzen unzuverlaessig sind), Icons referenzieren per
// <use href="#icon-NAME">. Keine Emojis im UI — immer diese Komponente
// (CLAUDE.md §17).
import { useEffect } from 'react';
import spriteRaw from '../../assets/icons-sprite.svg?raw';

const SPRITE_CONTAINER_ID = 'lorath-icon-sprite-react';

let spriteInjected = false;

function ensureSprite(): void {
  if (spriteInjected || typeof document === 'undefined') return;
  if (document.getElementById(SPRITE_CONTAINER_ID)) {
    spriteInjected = true;
    return;
  }
  const container = document.createElement('div');
  container.id = SPRITE_CONTAINER_ID;
  container.setAttribute('aria-hidden', 'true');
  container.style.position = 'absolute';
  container.style.width = '0';
  container.style.height = '0';
  container.style.overflow = 'hidden';
  container.innerHTML = spriteRaw;
  document.body.insertBefore(container, document.body.firstChild);
  spriteInjected = true;
}

export interface IconProps {
  /** Sprite-Name OHNE "icon-"-Prefix, z.B. "coin", "back", "settings". */
  name: string;
  /** Pixelgroesse (Breite = Hoehe). Default 24 wie das Sprite-Raster. */
  size?: number;
  className?: string;
  /** Optionales Label fuer Screenreader; ohne Label ist das Icon dekorativ. */
  label?: string;
  /** Spiegelt richtungsgebundene Icons (Pfeile/Chevrons) zentral in RTL. */
  directional?: boolean;
}

export function Icon({ name, size = 24, className, label, directional = false }: IconProps) {
  useEffect(() => {
    ensureSprite();
  }, []);

  return (
    <svg
      className={className ? `lorath-icon ${className}` : 'lorath-icon'}
      width={size}
      height={size}
      focusable="false"
      aria-hidden={label ? undefined : true}
      role={label ? 'img' : undefined}
      aria-label={label}
      data-directional={directional ? 'true' : undefined}
    >
      <use href={`#icon-${name}`} />
    </svg>
  );
}

export type IconName = string;
